import CommissionPaymentOffersSection from './CommissionPaymentOffersSection';
import type { UseCommissionOfferEditorResult } from '../../../hooks/useCommissionOfferEditor';
import { CommissionContractTemplate } from '../../../types/CommissionContractTemplate';

interface FeesTabSectionProps {
  contractTemplate: CommissionContractTemplate;
  offerEditor: Pick<
    UseCommissionOfferEditorResult,
    'editOpen' | 'openNewOffer' | 'openEditOffer' | 'createFirstOfferQuick' | 'isCreatingFirst'
  >;
  onRegisterOffersReload: (reload: () => Promise<void>) => void;
  onOffersChange?: (count: number) => void;
}

export default function FeesTabSection({
  contractTemplate,
  offerEditor,
  onRegisterOffersReload,
  onOffersChange,
}: FeesTabSectionProps) {
  return (
    <CommissionPaymentOffersSection
      editOpen={offerEditor.editOpen}
      isCreatingFirst={offerEditor.isCreatingFirst}
      onNewOffer={offerEditor.openNewOffer}
      onEditOffer={offerEditor.openEditOffer}
      onCreateFirstOffer={() => offerEditor.createFirstOfferQuick(contractTemplate)}
      onRegisterReload={onRegisterOffersReload}
      onOffersChange={onOffersChange}
    />
  );
}
